import { useReducedMotion } from "framer-motion";

// Marquee éditorial lent et élégant (pas un bandeau d'actualités rapide).
export default function Marquee({ items, className = "" }) {
  const reduced = useReducedMotion();
  const sequence = [...items, ...items];
  return (
    <div
      className={`marquee ${reduced ? "marquee--static" : ""} ${className}`}
      aria-hidden="true"
      data-testid="understanding-marquee"
    >
      <div className="marquee__track">
        {sequence.map((it, i) => (
          <span key={i} className="marquee__item">
            <span>{it}</span>
            <span className="marquee__dot">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
